import React from 'react';
import { useHistory } from 'react-router-dom';
import { FinishedDuplicateOfferSubscriptionQuery } from '../_graphql/subscriptions/duplicateOffer/FinishedDuplicateOfferSubscription';
import OperationStatusSection from './OperationStatusSection';
import ProgressModalSubscription from './ProgressModalSubscription';

const ModalDuplicateOffer = ({
  open,
  redirectTo,
  setIsOpen,
  error,
  userId,
  offerId
}) => {
  const history = useHistory();
  const extractStatus = response => response.finishedDuplicateOfferSubscription;
  const initialStatusDuplicateOffer = {
    step: 0,
    widgets: false,
    documents: false,
    rawDocuments: false,
    tags: false,
    globalVariables: false,
    folders: false,
    frames: false
  };

  const handleModalLoadingClick = () => redirectTo && history.push(redirectTo);

  return (
    <ProgressModalSubscription
      isOpen={open}
      subscription={FinishedDuplicateOfferSubscriptionQuery}
      variables={{ filter: { userId, itemIds: [`duplicateOffer-${offerId}`] } }}
      infoLoading={(status, progress, error) => (
        <OperationStatusSection
          operationType="la duplication de l'offre"
          items={[
            { label: 'Documents édités dupliqués', type: 'documents' },
            { label: 'Documents importés dupliqués', type: 'rawDocuments' },
            { label: 'Widgets dupliqués', type: 'widgets' },
            { label: 'Tags dupliqués', type: 'tags' },
            { label: 'Variables globales dupliquées', type: 'globalVariables' },
            { label: 'Dossiers dupliqués', type: 'folders' },
            { label: 'Trames de comparaison dupliquées', type: 'frames' }
          ]}
          status={status}
          progress={progress}
          errorMsg="Impossible de dupliquer correctement les éléments de l'offre, veuillez contacter l'équipe Flexidocs"
          showError={error}
        />
      )}
      onFinish={handleModalLoadingClick}
      extractStatus={extractStatus}
      initialStatus={initialStatusDuplicateOffer}
      setIsOpen={setIsOpen}
      error={error}
    />
  );
};

export default ModalDuplicateOffer;
